//
// import React from 'react'
// import {Switch, useRouteMatch} from "react-router-dom";
// import List from "./list";
// import Update from "./update";
// import {PrivateRoute} from "../../routes";
//
// const Routes = () => {
//     let { path } = useRouteMatch();
//     return (
//         <Switch>
//             <PrivateRoute exact path={path} component={List} permission={'external_service list'} />
//             <PrivateRoute path={`${path}/add`} component={Update} permission={'external_service add'} />
//             <PrivateRoute path={`${path}/edit/:id`} component={Update} permission={'external_service edit'} />
//         </Switch>
//     )
// }
// export default Routes


import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import SectionTitle from '../../components/section-title'
import {
	WidgetUsers,
	WidgetAdCampaigns,
	WidgetApps,
	WidgetBalance,
	WidgetDomains,
	WidgetInstalls,
	WidgetPushs,
	WidgetTeams
} from '../../components/widget'
import { useDashboard } from '../../service/api.swr'
import { OverlayLoader } from '../../components/loader'
import { WidgetLatestFinances } from '../../components/widget/latest.finances'
import { WidgetReferrals } from '../../components/widget/referrals'
import { WidgetTeamsInfo } from '../../components/widget/teams'
import { useAppSelector } from '../../redux/store'
import styled from "styled-components";

export const DashboardWidgetsWrapper = styled.div`
		display: grid;
		gap: 12px;
`

export const DashboardWidgetsGrid = styled.div`
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(2, 1fr);

		//	TODO: check the media transition point - 1440 ?
    @media (max-width: 1200px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

const WidgetsCont = styled.div`
		display: grid;
    grid-template-columns: repeat(3, 1fr);
    /*width: 560px;
		max-width: 100%;*/
    align-items: center;
    gap: 12px;
`

const WidgetCont = styled.div`

`

const Index = () => {
	const {t, i18n} = useTranslation();
	const {language: lang} = i18n;
	const dispatch = useDispatch();
	React.useEffect(() => {
		dispatch({
			type: 'SET_CONFIG_KEY',
			key: 'navbarTitle',
			value: t('nav_menu.section_menu.dashboard')
		})
	}, [dispatch, lang])
	const { settings } = useAppSelector();
	const { dashboard, isLoading, isError } = useDashboard();

	return (
		<OverlayLoader show={isLoading}>
			<DashboardWidgetsWrapper>
				{settings.monetization_active && <WidgetBalance />}

				<DashboardWidgetsGrid>
					{/*TODO: check the path to the data after BE is ready*/}
					<WidgetInstalls data={dashboard?.installs?.data ?? []} count={dashboard?.installs?.count ?? null}/>

					<WidgetsCont>
						<WidgetTeams count={dashboard?.total?.teams ?? null} />
						<WidgetUsers count={dashboard?.total?.users_all ?? null} />
						<WidgetPushs count={dashboard?.total?.pushs ?? null} />
						<WidgetDomains count={dashboard?.total?.domains ?? null} />
						<WidgetAdCampaigns count={dashboard?.total?.adcampaigns ?? null} />
						<WidgetApps count={dashboard?.total?.apps ?? null} />
					</WidgetsCont>
				</DashboardWidgetsGrid>

				<DashboardWidgetsGrid>
					<>
						<WidgetTeamsInfo total={dashboard?.total?.teams} data={dashboard?.teams} />
					</>

					{settings.referral_program_active &&
						<>
							<WidgetReferrals promoCode={dashboard?.promo_code} total={dashboard?.referrals?.total} totalInstalls={dashboard?.referrals?.total_installs} data={dashboard?.referrals?.last_4} />
						</>
					}
				</DashboardWidgetsGrid>
			</DashboardWidgetsWrapper>

			{/*<div className="grid grid-cols-1 lg:grid-cols-4 w-full gap-2 mb-2 lg:mb-4">*/}
			{/*	/!*widget*!/*/}
			{/*	{settings.monetization_active && <WidgetLatestFinances data={dashboard?.last_finances} className={`${dashboard?.teams?.length > 1 ? `lg:col-span-3` : `lg:col-span-4`}`} />}*/}
			{/*</div>*/}
		</OverlayLoader>
	)
}
export default Index
